import styled from 'styled-components';
import { gradient } from '../../../helpers/styleUtils';
import pulse from '../../../helpers/animPulseSmall';

export const GameButtonWrap = styled.span`
  bottom: -18px;
  opacity: 0;
  position: absolute;
  transform: rotateX(180deg) skew(20deg) translate(-50%, 10px);
  transition: opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut},
    transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut};
  transition-delay: 0.7s;

  .game-enter-done & {
    opacity: 1;
    transform: rotateX(0) skew(0) translate(-50%, 0);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    bottom: -25px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    bottom: -25px;
  }
`;

const GameButtonStyled = styled.button`
  ${gradient.background(
    `45deg`,
    props => props.theme.colors.quaternary,
    props => props.theme.colors.quinary
  )};
  border-radius: 30px;
  border: 0;
  box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.05);
  color: ${props => props.theme.colors.tertiary};
  cursor: pointer;
  font-family: ${props => props.theme.fonts.primary};
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.75vmin);
  font-weight: 700;
  outline: 0;
  padding: 10px 25px;
  text-align: center;
  transition: box-shadow ${props => props.theme.transition.duration}
    ${props => props.theme.transition.easeOut};

  &:disabled,
  &:disabled:hover,
  &:disabled:focus {
    ${gradient.background(
      `45deg`,
      props => props.theme.colors.grey1,
      props => props.theme.colors.dark
    )};
    box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.2), 0 0 0 8px rgba(0, 0, 0, 0.05);
    cursor: not-allowed;
    padding: 5px 20px;

    @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
      bottom: -25px;
      padding: 13px 40px;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      padding: 6px 50px;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
      padding: 6px 50px;
    }
  }

  &:hover,
  &:focus {
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.3), 0 0 0 10px rgba(0, 0, 0, 0.05),
      0 0 0 30px rgba(255, 255, 255, 0.2);

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      &:not([disabled]) {
        animation: ${pulse} 1s infinite
          ${props => props.theme.transition.easeOut};
      }
    }
  }

  &:not([disabled]):active {
    box-shadow: 0 0 0 20px rgba(255, 255, 255, 0.2),
      0 0 0 8px rgba(0, 0, 0, 0.05);
    transform: translateY(2px);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    padding: 13px 40px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.05);
    font-size: calc(${props => props.theme.fonts.baseSize} + 0.7vmin);
    padding: 13px 50px;
  }
`;

export const ButtonSVG = styled.svg`
  width: 20px;
  height: 20px;
  fill: ${props => props.theme.colors.white};
  filter: drop-shadow(2px 2px 0 rgba(0, 0, 0, 0.1));
  opacity: 0;
  position: relative;
  transform: translateY(15px);
  transition: opacity ${props => props.theme.transition.duration} ease-out,
    transform ${props => props.theme.transition.duration}
      ${props => props.theme.transition.cubicBez};
  transition-delay: 0.2s;

  .game-enter-done & {
    opacity: 1;
    transform: translateY(3px);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    width: 30px;
    height: 30px;

    .game-enter-done & {
      opacity: 1;
      transform: translateY(5px);
    }
  }
`;

export default GameButtonStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/GameButton/GameButton.styled.js